import { sendRequest } from '../../config';

export interface SigmaContext {
  country: number;
  ccedasegurado: string;

  ccedtitular?: string;
  locator?: number;  
  ccita?: string;  
  cciaseg?: string;
  ccliente?: string;
  cplan?: string;
  cproducto?: string;
  cbeneficio?: string;
  cprocedencia?: string;
  xcelular?: string;
  xemail?: string;
}

export interface SessionContextResponse {
  user_id: string;
  context: SigmaContext;
}

/**
 * Llama a POST /v2/signosvitales/context con la cookie sso_sid.
 * No requiere Bearer token — la autenticación es vía cookie SSO.
 * withCredentials es obligatorio para enviar la cookie cross-origin.
 */
export const getSessionContext = async (): Promise<SessionContextResponse> => {
  return sendRequest<SessionContextResponse>({
    method: 'post',
    path: 'v2/signosvitales/context',
    withCredentials: true,
    skipAuth: true,
  });
};
